import { useCallback } from 'react';

import { useUrlParams } from '~/hooks/useUrlParams';

/** The active tab in `?tab=`; the default tab leaves the URL clean, an unknown value falls back to it. */
export function useUrlTab<T extends string>(tabs: readonly T[], defaultTab: T) {
  const url = useUrlParams();
  const raw = url.get('tab');
  const tab = tabs.includes(raw as T) ? (raw as T) : defaultTab;
  const setTab = useCallback(
    (next: T) => url.set({ tab: next === defaultTab ? null : next }),
    [url, defaultTab],
  );
  return [tab, setTab] as const;
}
